<template>
  <div class="home">
    <el-container>
      <el-header>
        <!-- 左侧区域容器 -->
        <div class="left-section">
          <div @click="shoWMenu()" class="menuShow">
            <i
              :class="isMenuShow ? 'el-icon-s-unfold' : 'el-icon-s-fold'"
              style="color: #4d4f53"
            ></i>
          </div>

          <!-- 标题 -->
          <div class="title">
            <img
              src="../assets/images/8c084b3413674e170380cd5582be0b8a280b6fba.png"
              alt="Logo"
              class="logo-img"
            />

            <el-tooltip effect="light" :content="tooltipContent" placement="top">
              <span class="title-wrapper">
                <!-- PC / 平板 -->
                <span class="pc-title">
                  <span class="company-name">重庆川仪分析仪器有限公司 </span>
                  <span class="system-name">| 项目运营管理系统</span>
                </span>

                <!-- 手机 -->
                <span class="mobile-title">
                  川仪分析仪 | 项目运营管理系统
                </span>
              </span>
            </el-tooltip>
          </div>
        </div>

        <!-- 右侧用户区 -->
        <div class="right-user">
          <!-- 设置 -->
          <el-dropdown size="small" placement="bottom-start" @command="handleCommand">
            <span class="el-dropdown-link">
              <span class="setting"><i class="el-icon-setting"></i></span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="loginOut">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 推单 -->
          <el-dropdown size="small" placement="bottom-start" @command="handleCommand">
            <span class="el-dropdown-link">
              <span class="message"><i class="el-icon-bell"></i></span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <!-- <el-dropdown-item command="pushOrder">推单</el-dropdown-item> -->
              <el-dropdown-item command="cockpit3">异常信息</el-dropdown-item>
              <!-- <el-dropdown-item command="cockpit4">售后信息</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 驾驶舱 -->
          <el-dropdown size="small" placement="bottom-start" @command="handleCockpitCommand">
            <span class="el-dropdown-link">
              <span class="message"><i class="el-icon-data-analysis"></i></span>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="cockpit2">驾驶舱（管理）</el-dropdown-item>
              <el-dropdown-item command="cockpit1">驾驶舱（系统）</el-dropdown-item>
              <el-dropdown-item command="cockpit3">驾驶舱（水质）</el-dropdown-item>
              <el-dropdown-item command="processDesign">工艺流程设计</el-dropdown-item>
              <el-dropdown-item command="stationAdmin">工位管理</el-dropdown-item>
              <el-dropdown-item command="stationViewGas">工位总览（气体）</el-dropdown-item>
              <!-- <el-dropdown-item command="stationInfoGas">工位详情看板（气体）</el-dropdown-item> -->
            </el-dropdown-menu>
          </el-dropdown>

          <!-- 头像 -->
          <el-tooltip content="个人设置" placement="bottom" effect="light">
            <span class="avatar-container" @click="goToUserSettings">
              <div class="avatar-section">
                <el-avatar :src="currentUserAvatar" class="user-avatar">
                  {{ currentUserInitial }}
                </el-avatar>
              </div>
            </span>
          </el-tooltip>
        </div>
      </el-header>

      <el-container>
        <el-aside :width="asideWidth" :class="{ 'aside-collapsed': !isMenuShow || isMobile, 'aside-mobile-hidden': isMobile && !isMenuShow }">
          <div class="left-menu">
            <el-menu
              router
              :default-active="currentPath"
              class="el-menu-vertical-demo"
              background-color="rgba(37, 100, 207, 0)"
              text-color="#fff"
              active-text-color="#fff"
              :default-openeds="['1']"
            >
              <el-menu-item
                v-for="item in visibleMenu"
                :key="item.menuid"
                :index="'/homepage/' + item.url"
              >
                <i :class="item.icon"></i>
                <span v-if="isMenuShow && !isMobile" slot="title">{{ item.menuname }}</span>
                <span v-else slot="title" class="short-name">{{ item.shortname }}</span>
              </el-menu-item>
            </el-menu>
          </div>
        </el-aside>

        <el-main>
          <!-- ✅ .main-view：给内容一个「最小尺寸」，窗口再窄 / 再矮也保持排版，
               不够的部分由 el-main 出滚动条（而不是把内容挤变形） -->
          <div class="main-view">
            <!-- ✅ 无任何模块权限（urlPermission 为空 / 不匹配任何模块）：
                 内容区不留白，给出明确提示，也不再渲染任何主页。
                 ⚠️ 但「异常信息 / 售后信息」是总维度入口、不依赖模块权限，
                    在那些页面上必须照常渲染 router-view，否则跳过去看不到内容 -->
            <div v-if="showNoPermission" class="no-permission">
              <i class="el-icon-warning-outline"></i>
              <p class="no-permission-text">无权限，请联系管理员开通</p>
            </div>
            <keep-alive v-else include="homeContracts,homeProjects,homeWorkOrders,homeProducts,homeParts">
              <router-view />
            </keep-alive>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import { logout, homgPageMessage } from '@/api/mainapi.js';
import UserInfoUtils from '@/utils/userInfoUtils.js';
export default {

  name: 'homepage',
  data() {
    return {

      isMenuShow: true,
      isMobile: false,
      // currentPath: '/homepage/projects',
      // permission：模块编码 1项目 2合同 3生产 4产品 5部件（对应后端 urlPermission 编码）
      allmenu: [
        { menuid: 1, icon: 'el-icon-document', menuname: '项目管理', shortname: '项目', url: 'projects', permission: '1' },
        { menuid: 2, icon: 'el-icon-document', menuname: '合同管理', shortname: '合同', url: 'contracts', permission: '2' },
        { menuid: 3, icon: 'el-icon-document', menuname: '生产管理', shortname: '生产', url: 'workOrders', permission: '3' },
        { menuid: 4, icon: 'el-icon-document', menuname: '产品管理', shortname: '产品', url: 'products', permission: '4' },
        { menuid: 5, icon: 'el-icon-document', menuname: '部件管理', shortname: '部件', url: 'parts', permission: '5' }
      ],
      // ✅ 无模块权限也能访问的页面（顶栏下拉的「总维度」入口，不受 urlPermission 的 1~5 限制）
      publicPaths: [
        '/homepage/abnormalinfo',   // 异常信息
        '/homepage/aftersaleinfo'   // 售后信息
      ],
      currentUserName: '',
      currentUserAvatar: ''
    };
  },
  computed: {
    // 根据权限过滤后的菜单：管理员看全部；非管理员按 urlPermission 编码串（1项目 2合同 3生产 4产品 5部件）过滤，空/无权则不显示任何目录
    visibleMenu() {
      if (UserInfoUtils.isAdmin()) {
        return this.allmenu;
      }
      const permission = UserInfoUtils.getUrlPermission();
      if (!permission || permission === '0') return [];
      return this.allmenu.filter(item => permission.indexOf(item.permission) !== -1);
    },
    // 当前路由是否属于「无模块权限也能看」的页面（异常信息 / 售后信息）
    isPublicPath() {
      const path = this.$route.path;
      return this.publicPaths.some(p => path.indexOf(p) === 0);
    },
    // ✅ 是否显示「无权限」占位提示：
    //    没有任何模块权限，且当前不在白名单页面上 —— 此时内容区才留提示；
    //    在白名单页面（如异常信息）时必须照常渲染 router-view，否则跳过去也看不到内容
    showNoPermission() {
      return this.visibleMenu.length === 0 && !this.isPublicPath;
    },
    currentPath() {
    const path = this.$route.path;
    const segments = path.split('/').filter(Boolean);

    // /homepage：默认高亮可查看的最大模块主页（管理员→项目），无权则不高亮任何目录
    if (segments.length < 2) {
      const home = UserInfoUtils.getDefaultHomeRoute();
      return home === '/homepage' ? '' : home;
    }

    // 取第二段（project / projects / workOrder / workOrders ...）
    const raw = segments[1];

    // ✅ 统一映射表（单数 → 菜单 index）
    const menuMap = {
      project: '/homepage/projects',
      projects: '/homepage/projects',

      contract: '/homepage/contracts',
      contracts: '/homepage/contracts',

      workOrder: '/homepage/workOrders',
      workOrders: '/homepage/workOrders',

      product: '/homepage/products',
      products: '/homepage/products',

      part: '/homepage/parts',
      parts: '/homepage/parts'
    };

    const defaultPath = UserInfoUtils.getDefaultHomeRoute();
    return menuMap[raw] || defaultPath;
  },
    // 侧边栏宽度：手机端展开也是45px窄条、折叠时隐藏；非手机端展开全宽、折叠45px窄条
    asideWidth() {
      if (this.isMobile) {
        return this.isMenuShow ? '45px' : '0px';
      }
      return this.isMenuShow ? 'min(110px, 15vw)' : '45px';
    },
    tooltipContent() {
      return window.innerWidth < 768
        ? '项目运营管理系统'
        : '重庆川仪分析仪器有限公司 | 项目运营管理系统';
    },
    currentUserInitial() {
      if (this.currentUserName && this.currentUserName.length > 0) {
        return this.currentUserName.charAt(0).toUpperCase();
      }
      return 'U';
    }
  },
  mounted() {
    this.initMenuByScreen();
    window.addEventListener('resize', this.initMenuByScreen);
    this.loadUserInfo();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.initMenuByScreen);
  },
  methods: {
    initMenuByScreen() {
      this.isMobile = window.innerWidth <= 768;
      this.isMenuShow = window.innerWidth > 1400;
    },

    /** ✅ 是否手机端（实时取一次窗口宽度，避免 isMobile 还没随 resize 更新） */
    checkIsMobile() {
      return this.isMobile || window.innerWidth <= 768;
    },
    /**
     * 加载用户信息
     */
    loadUserInfo() {
      try {
        // 从 UserInfoUtils 获取用户信息
        const userInfo = UserInfoUtils.getAllUserInfo();
        
        // 设置用户名
        this.currentUserName = userInfo.username || '';
        
        // 设置头像 - 如果有头像URL就使用，否则为空（显示首字母）
        this.currentUserAvatar = userInfo.avatar || '';
        
      } catch (error) {
        this.currentUserName = '';
        this.currentUserAvatar = '';
      }
    },

    // 新增：跳转到用户设置页面
    goToUserSettings() {
      this.$router.push('/user/settings');
    },
    
    // 新增：处理头像点击事件
    handleAvatarCommand() {
      this.goToUserSettings();
      // if (command === 'userSettings') {
      //   this.goToUserSettings();
      // } else if (command === 'logout') {
      //   this.handleLogout();
      // }
    },

    // 新增驾驶舱菜单处理函数
    handleCockpitCommand(command) {
      // ✅ 手机端：除「工位管理」外都不支持，提示切换到电脑端
      // if (command !== 'stationAdmin' && this.checkIsMobile()) {
      if (this.checkIsMobile()) {
        // duration 默认 3000ms，这里改成 1 秒就消失
        this.$message({
          type: 'warning',
          message: '该页面暂不支持手机端，请切换到电脑端查看',
          duration: 1000
        });
        return;
      }

      if (command === 'cockpit1') {
        // 跳转到默认驾驶舱页面
        this.$router.push(`/productViewer`);
      } else if (command === 'cockpit2') {
        // 跳转到驾驶舱1页面，您可以根据实际路由修改
        this.$router.push(`/productViewer1`);
      }else if (command === 'cockpit3') {
        // 跳转到驾驶舱1页面，您可以根据实际路由修改
        this.$router.push(`/productViewer2`);
      }else if(command === 'processDesign') { // 新增分支
        this.$router.push(`/processDesign`); // 跳转到新定义的路由
      }else if(command === 'stationAdmin') { // 新增分支
        this.$router.push(`/stationAdmin`); // 跳转到新定义的路由
      }else if(command === 'stationViewGas') { // 新增分支
        this.$router.push(`/stationViewGas`); // 跳转到新定义的路由
      }else if(command === 'stationInfoGas') { // 新增分支
        this.$router.push(`/stationInfoGas`); // 跳转到新定义的路由
      }
    },


    async openMessage() {
      this.$refs.message.visible = true;
      this.$refs.message.startLoading();
      const timeout = setTimeout(() => {
        clearTimeout(timeout);
        this.$refs.message.loadingInstance.close();
        this.$message.warning('接口请求超时，请稍后重试');
      }, 120000);
      const res = await homgPageMessage();
      this.$refs.message.loadingInstance.close();
      if (res.data.code === 200 && res.data.data.length) {
        const data = res.data.data;
        const fbillnoArr = data.map((item) => item.fbillno);
        const str = fbillnoArr.join(',');
        this.homepageMsg = `任务单号：${str}`;
      } else if (res.status == 200 && res.data.code == 500) {
        this.homepageMsg = `暂无数据权限`;
      } else if (res.status == 500) {
        this.Countdown();
      }
    },
    // goToViewer(){
    //   this.$router.push(`/productViewer`);
    // },
    Countdown() {
      this.$refs.message.ifRefresh = true;
      this.restime--;
      this.homepageMsg = `服务器繁忙，请：${this.restime}秒后重试`;
      if (this.restime === 0) {
        this.homepageMsg = '';
        this.restime = 5;
        this.$refs.message.ifRefresh = false;
      } else {
        setTimeout(() => {
          this.Countdown();
        }, 1000);
      }
    },
    shoWMenu() {
      this.isMenuShow = !this.isMenuShow;
    },
    handleOpen() {},
    handleClose() {},
    // 根据传递的url跳转一级菜单路由

    toFirstLevel(url) {
      // 添加判断  当携带的url为空或者undefined 不跳转
      if (url) {
        this.$router.push(`/homepage/${url}`);
      }
    },


    async handleCommand(command) {
      if (command == 'loginOut') {
        this.$router.push(`/login`);
        await logout();
      }else if (command === 'cockpit3') { // 新增分支
        this.$router.push(`/homepage/abnormalinfo`); // 跳转到新定义的路由
      }else if (command === 'cockpit4') { // 新增分支
        this.$router.push(`/homepage/aftersaleinfo`); // 跳转到新定义的路由
      }





    }
  }
};
</script>


<style scoped lang="scss">
/* ============================================================
   窗口太窄 / 太矮时：内容区自动出滚动条
   ------------------------------------------------------------
   想改「触发滚动的临界值」只动下面两个变量调整固定页面大小参数：
   $min-view-w：主内容区的最小宽度（窗口比它窄 → 出现横向滚动条）
   $min-view-h：主内容区的最小高度（窗口比它矮 → 出现纵向滚动条）
   ============================================================ */
$min-view-w: 770px;
$min-view-h: 560px;

/* ================= 原有样式（精简保留） ================= */
  /* main */
  .home {
    background-color: #F4F6F9;
    flex: 1; /* 关键：占据剩余所有空间 */
    /* ⚠️ 必须有确定高度，否则下面 100% 高度链断掉，el-main 会被内容撑高而不是出滚动条。
       用 100vh 而不是 100%：#app 的 100% 拿到的是 body 的 auto 高度，链路会失效
       （子页面自己也是按 100vh 算的，保持一致） */
    height: 100vh;
    overflow: hidden; /* 外层不出滚动条，滚动交给内容区 el-main */
    padding: 0 !important;
      scrollbar-width: none;          /* Firefox */
  -ms-overflow-style: none;       /* IE / Edge Legacy */
  }

  /* Chromium 滚动条伪元素 */
  .home::-webkit-scrollbar {
    display: none !important;
    width: 0;
    height: 0;
  } 

  /* 高度链：.home(100vh) → 外层 el-container(100%) → 内层 el-container(可压缩) → el-main(滚动) */
  .home > .el-container {
    height: 100%;
  }
  /* 内层容器允许被压到比内容小（否则会把外层顶破，el-main 的滚动条就不出现了） */
  .home > .el-container > .el-container {
    min-height: 0;
  }

.el-header {
  background-color: #ffffff;
  // height: 6.6% !important;
  height: 50px !important;
  display: flex;
  justify-content: space-between;
  align-items: center; /* 垂直居中 */
  position: relative; /* 为伪元素提供定位上下文 */
  
    /* 左侧区域容器 */
  .left-section {
    display: flex;
    align-items: center;
    /* 取消 flex: 1，改为固定宽度或不设置，防止拉伸 */
    //  flex: 1;  /* 移除这行，防止拉伸 */
    width: clamp(50px, 100%, 602px);
    /* 确保靠左 */
    justify-content: flex-start;

    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #4D4F53;
      font-family:  "Microsoft YaHei", "微软雅黑", sans-serif;
      // font-size: clamp(1rem, 2.5vw, 1.3rem);
      font-size: 18px;
      font-weight: 700;
      line-height: 36px;
      letter-spacing: 0px;
      text-align: center;
      margin-left: 2%;
      /* 确保容器能正确收缩 */
      min-width: 0; /* 关键：允许flex项目收缩到小于其内容的最小尺寸 */
        
      .title-text {
        /* 文本溢出省略设置 */
        white-space: nowrap;       /* 禁止换行 */
        overflow: hidden;          /* 隐藏溢出部分 */
        text-overflow: ellipsis;   /* 超出显示省略号 */
        max-width: 100%;           /* 宽度自适应容器 */
        display: inline-block;     /* 确保省略号生效 */
      }

    }
      .logo-img {
      width: 32px;  /* 根据图片实际尺寸调整 */
      height: 25px; /* 根据图片实际尺寸调整 */
      margin-right: 10px; /* 图片和文字之间的间距 */
      vertical-align: middle; /* 垂直居中对齐 */
    }

  }
  

  .right-user {
    display: flex;
    flex-direction: row;
    align-items: center;
    span {
      font-size: 1.5rem;
      color:rgba(37, 100, 207, 0.8);
      margin-right: 10px;
      font-weight: bold; /* 新增：设置粗体,但好像没用*/
    }
  }
}
  
/* 添加幻彩蓝描边渐变描边伪元素 */
.el-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px; /* 描边高度 */
  background: linear-gradient(to right, 
    rgb(29, 194, 213), 
    rgba(37, 100, 207, 0.8), 
    rgb(25, 137, 250)
  );
}


.el-aside {
  background: rgba(37, 100, 207, 0.8);
  transition: width 0.3s ease;
  overflow: hidden;
}

//侧边栏折叠态
.aside-collapsed {
  .left-menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 10px;
  }

  .el-menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .el-menu-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 10px 4px !important;
    height: auto !important;
    line-height: 1.2 !important;
    text-align: center;

    i {
      font-size: 18px;
      margin-right: 0 !important;
      margin-bottom: 3px;
    }

    .short-name {
      font-size: 10px;
      color: #ffffff;
      white-space: nowrap;
    }
  }

  // 选中态和悬停态在折叠时也不变
  /deep/.el-menu .el-menu-item:hover,
  /deep/.el-menu .el-menu-item.is-active {
    .short-name {
      color: #ffffff !important;
      font-weight: 700;
    }
  }
}

// 手机端折叠时完全隐藏侧边栏
.aside-mobile-hidden {
  padding: 0 !important;
  min-width: 0 !important;
  overflow: hidden;
}

// .el-main {
//   background: #f4f6f9;
//   padding: 5px !important;
// }

.title-wrapper {
  display: inline-flex;
  
  align-items: center;
  
}

.title {
      color: #4D4F53;
      font-size: 24px;
      font-family:  "Microsoft YaHei", "微软雅黑", sans-serif;

}


// .right-user {
//   display: flex;
//   align-items: center;
//   span {
//     font-size: 20px;
//     margin-right: 10px;
//   }
// }
.right-user {
  display: flex;
  flex-direction: row;
  align-items: center;
  span {
    font-size: 1.5rem;
    color:rgba(37, 100, 207, 0.8);
    margin-right: 10px;
    // font-weight: bold; /* 新增：设置粗体,但好像没用*/
  }
}

/* PC / 平板 */
.pc-title {
  display: inline;
  color: #4D4F53;
  .company-name {
    font-weight: 700;   // 加粗
  }

  .system-name {
    font-weight: 400;   // 不加粗（正常字重）
  }
}

.mobile-title  {
  display: none;
}



.left-menu {
  height: 100%;
  overflow-y: auto; /* 关键：允许菜单内容滚动 */
  overflow: auto; /* 关键：允许菜单内容滚动 */
  // padding: 30px 0 0 0 
  
}

  /* ================= 内容区：太窄 / 太矮时出滚动条 ================= */
  .el-main {
    background-color: white;
    flex: 1; /* 关键：占据剩余所有空间 */
    /* ⚠️ 关键：min-width/min-height:0 允许它被压得比内容小（否则内容会把外层顶破，
       滚动条就出现在外层而不是这里）；overflow:auto = 「内容超出才出滚动条」 */
    min-width: 0;
    min-height: 0;
    overflow: auto;
    padding: 0 !important;
    /* 滚动条：细一点，不抢视觉（只在真的溢出时才出现） */
    scrollbar-width: thin;                    /* Firefox */
    scrollbar-color: rgba(172, 177, 187, 0.35) transparent;
  }

  /* 内容层：给一个「不至于挤变形」的最小尺寸 —— 不够的部分由 el-main 滚动 */
  .main-view {
    height: 100%;
    box-sizing: border-box;
  }

  /* ✅ 无权限占位：整块内容区居中提示
     （.main-view > * 已有 height:100% !important，这里直接撑满后居中即可） */
  .no-permission {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    box-sizing: border-box;
    user-select: none;

    i {
      font-size: 42px;
      color: #c0c4cc;
    }

    .no-permission-text {
      margin: 0;
      font-size: 15px;
      color: #909399;
      letter-spacing: 1px;
    }
  }

  /* 子页面普遍写死了 height: calc(100vh - 65px)，窗口变矮时它会跟着 vh 一起变矮，
     永远撑不出滚动条。这里统一改成「跟随容器高度」，容器最小高度由 .main-view 保证。 */
  .main-view > * {
    height: 100% !important;
  }

  /* 非手机端才强制最小尺寸：手机端保持原来的响应式排版，不强制横向滚动 */
  @media (min-width: 769px) {
    .main-view {
      min-width: $min-view-w;   /* 窗口比这窄 → 横向滚动条 */
      min-height: $min-view-h;  /* 窗口比这矮 → 纵向滚动条 */
    }
  }

  /* Chromium 滚动条伪元素 */
  .el-main::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }
  .el-main::-webkit-scrollbar-thumb {
    background: rgba(172, 180, 195, 0.35);
    border-radius: 4px;
  }
  .el-main::-webkit-scrollbar-thumb:hover {
    background: rgba(144, 153, 170, 0.55);
  }
  .el-main::-webkit-scrollbar-track {
    background: transparent;
  }

/* 这是侧边栏文字颜色
   ⚠️ 原来是 justify-content: space-between + span{width:100%}，
      图标被顶到最左、文字被顶到最右，看着是散开的。
      这里统一改成「以左边为基准」：左边留固定的边距，图标和文字之间固定留一点间距。 */
.el-menu-item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  /* 左边距：和 Element 默认的 20px 一致，想更窄 / 更宽改这一个值 */
  padding-left: 10px !important;

  /* 标题文字（el-menu-item 里 <i> 是图标、<span> 就是标题，见 Element 的 menu-item 模板） */
  span {
    width: auto;               /* 原来是 100%，会把文字整个撑满并挤到最右 */
    min-width: 0;              /* 允许收缩，文字过长时才好出现省略号 */
    font-size: 12px;
    color: #ffffff;
    text-align: left;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* 图标：Element 默认给 5px 右边距，这里显式定成 8px（图标 ↔ 文字的间距），
     并且不允许被压缩，保证每一行图标都落在同一条竖线上 */
  i {
    margin-right: 2px !important;
    flex: none;
  }
}

.left-menu {
  height: 100%;
  overflow: hidden;
  // padding: 30px 0 0 0
}
.el-menu {
  // height: 100%;
  // padding-top: 20%;
  // padding: 5% 0;
  flex: 0.5; /* 菜单充满整个left-menu */
  border-right:none;
}
/* 单独修改“主页”图标的颜色 */
.el-icon-document {
  color: #ffffff !important; /* 红色图标 */
}

// 悬停状态菜单项的样式
/deep/.el-menu .el-menu-item:hover {
  outline: 0 !important;
  span {
    color: #ffffff !important;
    // font-size: 14px;
    font-weight: 700;
  }
  background: rgba(37, 100, 207, 0.4)  !important;
}

// 激活状态菜单项的样式
/deep/.el-menu .el-menu-item.is-active {
  span {
    // font-size: 14px;
    font-weight: 700;
    color: #ffffff;
  }
  background: rgba(37, 100, 207, 0.8) !important;
}

/* ================= 手机端（核心） ================= */
@media (max-width: 768px) {
.el-header {
  background-color: #ffffff;
  // height: 6.6% !important;
  height: 65px !important;
  display: flex;
  justify-content: space-between;
  align-items: center; /* 垂直居中 */
  position: relative; /* 为伪元素提供定位上下文 */
  
    /* 左侧区域容器 */
  .left-section {
    display: flex;
    align-items: center;
    /* 取消 flex: 1，改为固定宽度或不设置，防止拉伸 */
    //  flex: 1;  /* 移除这行，防止拉伸 */
    width: clamp(50px, 100%, 602px);
    /* 确保靠左 */
    justify-content: flex-start;

    .title {
      display: flex;
      flex-direction: row;
      align-items: center;
      color: #4D4F53;
      font-family:  "Microsoft YaHei", "微软雅黑", sans-serif;
      // font-size: clamp(1rem, 2.5vw, 1.3rem);
      font-size: 15px;
      font-weight: 700;
      line-height: 36px;
      letter-spacing: 0px;
      text-align: center;
      margin-left: 2%;
      /* 确保容器能正确收缩 */
      min-width: 0; /* 关键：允许flex项目收缩到小于其内容的最小尺寸 */
        
      .title-text {
        /* 文本溢出省略设置 */
        white-space: nowrap;       /* 禁止换行 */
        overflow: hidden;          /* 隐藏溢出部分 */
        text-overflow: ellipsis;   /* 超出显示省略号 */
        max-width: 100%;           /* 宽度自适应容器 */
        display: inline-block;     /* 确保省略号生效 */
      }

    }
  .logo-img {
    width: 32px;
    height: 22px;
    margin-right: 6px;
    
  }

  }

  .right-user {
    display: flex;
    flex-direction: row;
    align-items: center;
    span {
      font-size: 1.5rem;
      color:rgba(37, 100, 207, 0.8);
      margin-right: 10px;
      font-weight: bold; /* 新增：设置粗体,但好像没用*/
    }
  }
}


  /* header */
  .el-header {
    height: 48px !important;
    padding: 0 8px;
    
    .right-user {
      display: flex;
      flex-direction: row;
      align-items: center;
      span {
        font-size: 1rem;
        color:rgba(37, 100, 207, 0.8);
        margin-right: 5px;
        font-weight: bold; /* 新增：设置粗体,但好像没用*/
      }
    }

    /* ✅ 手机端：头像圆圈小一点（el-avatar 默认 40px → 26px），并在竖直方向真正居中 */
    .avatar-container {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin-left: 2px;
      vertical-align: middle;   /* 消除行内元素的基线错位 */
    }

    /* ⚠️ 偏上的根因：el-avatar 是 inline-block，放在 div 里会按「基线」对齐，
       下方留出 descender 空间 → 视觉上就比左边的图标高一截。
       改成 flex 居中 + 去掉行高占位即可。 */
    .avatar-section {
      display: flex;
      align-items: center;
      justify-content: center;
      line-height: 0;
    }

    .avatar-section ::v-deep .el-avatar,
    .avatar-section ::v-deep .user-avatar {
      width: 26px !important;
      height: 26px !important;
      line-height: 26px !important;
      font-size: 14px !important;
      vertical-align: middle !important;
    }
  }



/* 添加幻彩蓝描边渐变描边伪元素 */
.el-header::after {
  height: 3px; /* 描边高度 */

}


  .pc-title {
    display: none;
  }

  .mobile-title {
    display: inline;
    font-size: 12px;
    // max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
  }



  /* main：手机端也保留滚动能力（内容真的装不下时可以直接滑），
     但不强制最小尺寸，避免破坏原本的响应式排版（比如小屏出现横向滚动条） */
  .el-main {
    background-color: white;
    flex: 1; /* 关键：占据剩余所有空间 */
    min-width: 0;
    min-height: 0;
    overflow: auto;
    padding: 0 !important;
    scrollbar-width: thin;
    scrollbar-color: rgba(172, 177, 187, 0.35) transparent;
  }

  /* Chromium 滚动条伪元素 */
  .el-main::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  .el-main::-webkit-scrollbar-thumb {
    background: rgba(196, 205, 221, 0.35);
    border-radius: 3px;
  }
  .el-main::-webkit-scrollbar-track {
    background: transparent;
  }
}
</style>